import { Form, Typography } from 'antd';
import cn from 'classnames';

import { RULES_IS_REQUIRE } from '@app/constants';

import type { FormItemProps } from 'antd';

import '../../styles/FormItemField.desktop.scss';

const { Text } = Typography;

type FieldProps = {
  label: string;
  fieldName: string | number | (string | number)[];
  required?: boolean;
  children: React.ReactNode;
  rules?: FormItemProps['rules'];
  getValueFromEvent?: FormItemProps['getValueFromEvent'];
  getValueProps?: FormItemProps['getValueProps'];
  className?: string;
  validateStatus?: 'success' | 'warning' | 'error' | 'validating';
  isStrongTitle?: boolean;
};

export const FormItemField = ({
  label,
  fieldName,
  required,
  children,
  rules,
  getValueFromEvent,
  getValueProps,
  className = '',
  validateStatus,
  isStrongTitle = true,
}: FieldProps) => (
  <div className={cn('field-container', className)}>
    <Text
      strong={isStrongTitle}
      className={required ? 'label-require' : undefined}
    >
      {label}
    </Text>

    <Form.Item
      name={fieldName}
      rules={[...(required ? RULES_IS_REQUIRE : []), ...(rules ?? [])]}
      getValueFromEvent={getValueFromEvent}
      getValueProps={getValueProps}
      validateStatus={validateStatus}
    >
      {children}
    </Form.Item>
  </div>
);
